<template>
  <PageHeader data-test="integrations-page">
    <template #header-title>{{ $t('Webhooks') }}</template>
    <template #header-actions>
      <WdsButton primary data-test="create-webhook" @click="showCreate = true">
        {{ $t('Create Webhook') }}
      </WdsButton>
    </template>
    <template #header-description>
      {{ $t('Keep your platform informed when an event happens in Worksome') }}
      <WdsButtonText
        class="wds-text-button-primary pull-right"
        href="https://docs.worksome.com/webhooks/"
        target="_blank"
      >
        {{ $t('Webhooks Developer Documentation') }}
      </WdsButtonText>
    </template>
  </PageHeader>
  <WdsTabs :active-tab-key="toggledOption" @update:active-tab-key="handleToggle">
    <WdsTab :title="$t('Manage')" :tab-key="WebhookTabs.MANAGE" data-test="webhooks-manage-tab">
      <WebhookManage />
    </WdsTab>
    <WdsTab :title="$t('Event logs')" :tab-key="WebhookTabs.EVENTS" data-test="webhooks-events-tab">
      <WebhookEventLog />
    </WdsTab>
  </WdsTabs>

  <teleport to="#modals">
    <WebhookModalCreate v-model:show="showCreate" />
  </teleport>
</template>

<script setup lang="ts">
import { WdsButton, WdsButtonText , WdsTabs, WdsTab } from '@worksome/wds-components'
import { ref } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import WebhookModalCreate from '@/components/Integrations/Webhooks/WebhookModalCreate.vue'
import PageHeader from '@/components/PageHeader.vue'
import { WebhookTabs } from '@/components/Integrations/Webhooks/types'
import WebhookManage from '@/components/Integrations/Webhooks/WebhookManage.vue'
import WebhookEventLog from '@/components/Integrations/Webhooks/WebhookEventLog.vue'

const showCreate = ref(false)

const emit = defineEmits(['tab-toggled'])

const toggledOption = ref(WebhookTabs.MANAGE)

const handleToggle = (optionKey) => {
  toggledOption.value = optionKey
  emit('tab-toggled', optionKey)
}
</script>

<style scoped lang="scss">
.wds-text-button-primary {
  color: #6a54f4;
  border-bottom-color: #6a54f4;
  &:hover {
    border-bottom-color: #6a54f4;
  }
}
</style>
